const USERS = '/users'
const userBuilder = (id) => `${USERS}/${id}`
export {
    USERS,
    userBuilder
}
